import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { PlanIcon, RightArrowIcon } from "../../Assets/Icons";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { GET_SUBSCRIPTION_LIST } from "../../apiClient/apiEndpoints";
import { SUBSCRIPTION_LIMIT } from "../../Constant/constant";
import Skeleton from "react-loading-skeleton";
import PlanSkeleton from "../../Skeleton/PlanSkeleton";
const planNumber = (index) => String(index + 1).padStart(2, "0");

const transformSubscriptions = (subscriptions) => {
  return subscriptions.map((sub) => {
    let applications = 0;
    let resources = 0;

    for (let allocation of sub.allocations) {
      if (allocation.applicationId) applications++;
      if (allocation.resourceId) resources++;
    }

    return {
      id: sub.id,
      uuid: sub.uuid,
      data: sub.data,
      applications,
      resources,
      status: "Active",
      amount: `₹ ${sub.amount}`,
    };
  });
};

const PlansList = ({ uuid }) => {
  const [hasMore, setHasMore] = useState(true);
  const [paginationPage, setPaginationPage] = useState(1);
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAllSubscriptionList = async (pageId) => {
    try {
      setLoading(true);
      let pageNumber = pageId || paginationPage;
      let data = await apiClient.get(`${SSO_URL}${GET_SUBSCRIPTION_LIST}/${uuid}`, {
        params: {
          limit: SUBSCRIPTION_LIMIT,
          page: pageNumber,
        },
      });

      setList((pre) => (pageNumber == 1 ? [...data] : [...pre, ...data]));
      setHasMore(data.length === SUBSCRIPTION_LIMIT);
      setPaginationPage(data.length === SUBSCRIPTION_LIMIT ? Number(pageNumber) + 1 : 1);
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
    }
  };

  const loadMoreData = () => {
    getAllSubscriptionList(paginationPage);
  };

  useEffect(() => {
    getAllSubscriptionList(1);
  }, [uuid]);

  return (
    <>
      <div id="scrollableDivGroups" style={{ height: "100%", width: "100%", overflow: "auto" }} className="scrollable-container" >

        {!loading && list.length ===0 ? 
          <div className="noOrgContent">
          <h6>No Subscriptions found</h6>
          <p>
          This organization doesn’t have any subscriptions yet.  <br/>
          Click the “Create New Subscription” button above to add one.
          </p>
        </div>
        :

        <InfiniteScroll
          scrollThreshold={0.7}
          dataLength={list.length}
          next={() => loadMoreData()}
          hasMore={hasMore}
          loader={<PlanSkeleton length = {5}/>}
          scrollableTarget="scrollableDivGroups"
        >
        
        {list.map((plan, index) => (
          <div
            className={`plan-item ${plan.status === "Active" ? "active" : "inactive"}`}
            onClick={() => navigate(`/organization/manage/subscription/plans/${uuid}/${plan.uuid}`)}
            key={plan.id}
          >
            <div className="plan-name-info">
              <span className="icon-here">
                <PlanIcon />
              </span>
              <div className="name-info">
                <h6>{`Plan ${planNumber(index)}`}</h6>
                <div className="resource-info">
                  <p>
                    <span>{plan.applications} </span>
                    Application
                  </p>
                  <p>
                    <span>{plan.resources}</span> Resource
                  </p>
                  <p>
                    Left Days <span>{plan.daysLeft}</span>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="plan-price">
                <p>{plan.amount}</p>
                <span>
                  <RightArrowIcon />
                </span>
              </div>
              <p className="activeinactive">
                <span className={plan.status === "Active" ? "bg-success" : "bg-secondary "}></span>{" "}
                {plan.status}
              </p>
            </div>
          </div>
        ))}
          
        </InfiniteScroll>
          }
      </div>
    </>
  );
};

export default PlansList;
